import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { removeSelectedIdsPerPage, selectAllIdsPerPage } from '../../actions/bulk-edit-actions';
import { FormContext } from '../../context';
import {
  isAllRowsPerPageSelected,
  isSelectedRecordOnCurrentPage,
} from '../../selectors/bulk-edit.selectors';

const useStyles = makeStyles({
  headerCheckbox: {
    '& .MuiCheckbox-root': {
      top: 0,
    },
    '& .MuiFormControlLabel-label': {
      display: 'none',
    },
    minHeight: '0px !important',
    marginRight: '20px !important',
  },
});

const SelectAllHeaderCheckbox = ({ rows = [] }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const formKey = useContext(FormContext);

  const isAllRecordsPerPageSelected = useFormSelector(isAllRowsPerPageSelected, {
    allRowsPerPage: rows,
  });
  const isSelectedOnCurrentPage = useFormSelector(isSelectedRecordOnCurrentPage, {
    allRowsPerPage: rows,
  });

  const onCheckboxHeaderChange = () => {
    if ((isSelectedOnCurrentPage && !isAllRecordsPerPageSelected) || isAllRecordsPerPageSelected) {
      dispatch(removeSelectedIdsPerPage(formKey, rows));
      return;
    }
    dispatch(selectAllIdsPerPage(formKey, rows));
  };

  return (
    <Checkbox
      className={classes.headerCheckbox}
      checked={isAllRecordsPerPageSelected}
      onChange={onCheckboxHeaderChange}
      indeterminate={isSelectedOnCurrentPage && !isAllRecordsPerPageSelected}
    />
  );
};

export const selectAllHeader = (rows) => <SelectAllHeaderCheckbox rows={rows} />;
